import VoiceMail from "./VoiceMail";

export * from "./AlarmClock";
export * from "./AlarmClockCheck";
export * from "./AlarmClockOff";
export * from "./AlarmClockPlus";
export * from "./AlarmSmoke";
export * from "./BellElectric";
export * from "./Calculator";
export * from "./Cpu";
export * from "./DaimondMinus";
export * from "./DaimondPlus";
export * from "./Disc";
export * from "./Disc2";
export * from "./Disc3";
export * from "./DiscAlbum";
export * from "./Drill";
export * from "./Drum";
export * from "./Flashlight";
export * from "./FlashlightOff";
export * from "./Gamepad";
export * from "./Gamepad2";
export * from "./HdmiPort";
export * from "./Joystick";
export * from "./KeyboardMusic";
export * from "./Laptop";
export * from "./LaptopMinimal";
export * from "./Microchip";
export * from "./MicVocal";
export * from "./Mouse";
export * from "./MouseOff";
export * from "./PcCase";
export * from "./Piano";
export * from "./PlugZap";
export * from "./RadioReceiver";
export * from "./RadioTower";
export * from "./Scan";
export * from "./ScanLine";
export * from "./ScanText";
export * from "./Speaker";
export * from "./Tablet";
export * from "./TabletSmartphone";
export * from "./TvMinimal";
export * from "./TvMinimalPlay";
export * from "./Usb";
export * from "./VoiceMail";

export const Device = {
  VoiceMail,
};
